import { useAtomValue } from "jotai";
import { DEFAULT_STATION } from "./constants";
import { persistentAtom } from "./utils/persistentAtom";

export const stationsState = persistentAtom("stationsState", [DEFAULT_STATION]);

export const useStations = () => useAtomValue(stationsState);
